export function showPlaceholder(value, test) {
  return test ? value : "";
}
